const terminalWindow = document.getElementById('terminal-window');
const terminalBody = document.getElementById('terminal-body');
const terminalLines = document.getElementById('terminal-lines');
const terminalInput = document.getElementById('terminal-input');
const terminalOverlay = document.getElementById('terminal-overlay');

let isActive = false;
let history = [];
let historyIndex = -1;

const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

const addLine = (text, cls = "") => {
    const div = document.createElement('div');
    if (cls) div.className = cls;
    div.textContent = text;
    terminalLines.appendChild(div);
    scrollToBottom();
};

const addBlock = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    terminalLines.appendChild(div);
    scrollToBottom();
};

const clearTerminal = () => {
    terminalLines.innerHTML = '';
};

const scrollToBottom = () => {
    terminalBody.scrollTop = terminalBody.scrollHeight;
};

const showBanner = () => {
    addBlock(`
<pre class="text-green-400">
 ██████╗  ██████╗ ██████╗ ██╗
██╔════╝ ██╔═══██╗██╔══██╗██║
██║  ███╗██║   ██║██████╔╝██║
██║   ██║██║   ██║██╔═══╝ ██║
╚██████╔╝╚██████╔╝██║     ██║
 ╚═════╝  ╚═════╝ ╚═╝     ╚═╝

GOPI KRISHNAN
Cloud Infrastructure & DevOps Engineer
</pre>

<div class="text-yellow-400 font-bold mt-2">👨‍💻 GOPI KRISHNAN TERMINAL PORTFOLIO</div>
<div class="text-gray-400 mt-2">Type 'help' to see available commands.</div>
    `);
};

const boot = async () => {
    addLine("Booting Gopi Krishnan Cloud Terminal...", "text-cyan-400");
    await sleep(1000);
    addLine("Loading modules...");
    await sleep(1000);
    addLine("Initializing portfolio...");
    await sleep(1000);

    clearTerminal();
    showBanner();
};

const handleCommand = (cmd) => {
    switch (cmd.toLowerCase().trim()) {
      case "help":
        addBlock(`
<br>Available Commands:<br><br>
about - About me<br>
skills - My skills<br>
projects - My projects<br>
contact - Contact details<br>
github - My GitHub profile<br>
photo - My image<br>
clear - Clear terminal<br>
exit - Exit portfolio<br>
        `);
        break;

      case "about":
        addBlock(`
<br>Name : <b class="text-yellow-400">GOPI KRISHNAN P</b><br>
Role : Cloud Infrastructure & DevOps Engineer<br>
Goal : Building scalable cloud solutions with AWS, Kubernetes & Infrastructure Automation<br><br>
Currently working on:<br>
- Multi-AZ AWS Infrastructure Architecture<br>
- MQTT-based IoT Solutions<br>
- Kubernetes & Container Orchestration<br>
        `);
        break;

      case "skills":
        addBlock(`
<br>Technical Skills:<br><br>
• AWS (EC2, S3, Lambda, VPC, RDS, CloudWatch, Route 53)<br>
• Terraform & Ansible<br>
• Docker & Kubernetes<br>
• Python & Flask<br>
• Jenkins & GitHub Actions<br>
• Prometheus & Grafana<br>
• Security: IAM, Burp Suite, Nmap, Wireshark<br>
        `);
        break;

      case "projects":
        addBlock(`
      🏠 1. <a href="https://gopikrishnan.engineer/3d/" target="_blank" class="text-cyan-400 hover-underline font-bold">
      Gopi's Cloud - 3D Interactive Kame House Portfolio 🚀</a><br><br>
      ☁ 2. <a href="https://kooraq.me" target="_blank" class="text-cyan-400 hover-underline">
      KooraQ - On-Demand Service Platform</a><br><br>
      🌱 3. <a href="https://github.com/gopiO-O/Intelligent-seed-prediction-and-recommendation-system" target="_blank" class="text-cyan-400 hover-underline">
      Intelligent Seed Prediction System</a><br><br>
      🔌 4. <a href="https://github.com/gopiO-O/Underwater-robot-web-application" target="_blank" class="text-cyan-400 hover-underline">
      Underwater Robot for Inspection and Salvage</a><br>
        `);
        break;

      case "house":
      case "3d":
      case "kamehouse":
      case "cloud":
        addBlock(`
      <br>🏠 <b class="text-yellow-400">Gopi's Cloud - 3D Interactive Kame House Portfolio</b><br>
      An immersive Three.js & R3F 3D interactive world featuring AWS, Azure, Kubernetes, and Cloud & DevOps milestones.<br><br>
      👉 <a href="https://gopikrishnan.engineer/3d/" target="_blank" class="text-cyan-400 hover-underline font-bold">
      Launch 3D House Experience (https://gopikrishnan.engineer/3d/) 🚀</a><br>
        `);
        break;

      case "github":
        addBlock(`
      <br>🐙 GitHub:<br>
      <a href="https://github.com/gopiO-O" target="_blank" class="text-cyan-400 hover-underline">
      github.com/gopiO-O</a><br>
        `);
        break;

      case "contact":
        addBlock(`
      <br>📧 Email:<br>
      <a href="mailto:mistercalifornia007@gmail.com" class="text-cyan-400 hover-underline">
      mistercalifornia007@gmail.com</a><br><br>
💼 LinkedIn:<br>
<a href="https://www.linkedin.com/in/mistercalifornia/" target="_blank" class="text-cyan-400 hover-underline">
www.linkedin.com/in/mistercalifornia/</a><br><br>
📱 Phone:<br>
      +91 7094298001<br>
        `);
        break;

            case "photo":
        addBlock(`
      <img src="/project_one.png" class="w-64 rounded-lg border border-green-400 mt-2" alt="Gopi Krishnan"/>
        `);
        break;

      case "clear":
        clearTerminal();
        break;

      case "exit":
        addLine("Closing portfolio... 👋 Goodbye!", "text-cyan-400 mt-2");
        deactivateTerminal();
        break;

      default:
        addLine("Command not found. Type 'help'", "text-red-400 mt-2");
    }
};

const activateTerminal = () => {
    isActive = true;
    terminalOverlay.style.display = 'none';
    terminalInput.disabled = false;
    terminalInput.classList.remove('inactive');
    terminalInput.classList.add('active');
    terminalInput.focus();
};

const deactivateTerminal = () => {
    isActive = false;
    terminalOverlay.style.display = 'block';
    terminalInput.disabled = true;
    terminalInput.classList.remove('active');
    terminalInput.classList.add('inactive');
};

terminalWindow.addEventListener('click', activateTerminal);

terminalInput.addEventListener('keydown', (e) => {
    if (!isActive) return;

    if (e.key === "Enter") {
        const inputVal = terminalInput.value;
        if (inputVal.trim() !== "") {
            history.push(inputVal);
            historyIndex = history.length;
      }

      addBlock(`<span class="text-yellow-400">gopi@portfolio:~$</span> ${inputVal}`);
        handleCommand(inputVal);
        terminalInput.value = "";
    }

    if (e.key === "ArrowUp") {
        e.preventDefault();
        if (historyIndex > 0) {
            historyIndex--;
            terminalInput.value = history[historyIndex];
        }
    }

    if (e.key === "ArrowDown") {
        e.preventDefault();
        if (historyIndex < history.length - 1) {
            historyIndex++;
            terminalInput.value = history[historyIndex];
        } else {
            historyIndex = history.length;
            terminalInput.value = "";
        }
    }
});

// Boot when loaded
boot();
